import { useState } from 'react'
import { useOutlet } from 'react-router-dom'

/**
 * The route this element was created for, kept for its whole life (BUG-479).
 *
 * RootLayout fades pages with AnimatePresence keyed on the pathname. A plain
 * <Outlet /> in the leaving element already renders the NEW route, so every
 * client-side navigation mounted the new page twice: its effects ran twice
 * (analytics events, data fetches) and the leaving fade showed the new page.
 * Freezing the outlet keeps the leaving page's own content until it is gone.
 * Hooks inside the page still read live context (search params, stores).
 */
export default function FrozenOutlet() {
  const outlet = useOutlet()
  const [frozen] = useState(outlet)
  return frozen
}
